import BecomePartnerContainer from './BecomePartnerContainer';

export {
    BecomePartnerContainer
};

export default BecomePartnerContainer;